"use client";

import GradientButtonIcon from "@/components/ui/custom/gradient-button-icon";
import { ArrowRight } from "lucide-react";
import React from "react";

function ButtonSectionCustomCrmThat() {
  return (
    <div className="mt-8 text-center lg:text-left">
      <GradientButtonIcon icon={<ArrowRight className="h-5 w-5" />}>
        Build CRM for your Business
      </GradientButtonIcon>
    </div>
  );
}

export default ButtonSectionCustomCrmThat;
